<h1 mat-dialog-title>Añadir nuevo proveedor</h1>
<mat-dialog-content [formGroup]="providerForm">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Nombre</mat-label>
          <input type="text" matInput formControlName="name" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Correo electrónico</mat-label>
          <input type="email" matInput formControlName="email" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Teléfono móvil</mat-label>
          <input type="tel" matInput placeholder="+34.666 555 444" formControlName="phone" />
          <mat-icon matSuffix>phone</mat-icon>
          <mat-hint>Formato deseado: +xx.xxx xxx xxx</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Página web</mat-label>
          <input type="text" matInput formControlName="website" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Identificador (slug)</mat-label>
          <input type="text" matInput formControlName="slug" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-checkbox formControlName="is_hosting_provider">Es proveedor de hosting</mat-checkbox>
      </div>
      <div class="col-12 col-lg-4">
        <mat-checkbox formControlName="is_domain_provider">Es proveedor de dominio</mat-checkbox>
      </div>
      <div class="col-12 col-lg-4">
        <mat-checkbox formControlName="is_business_mail_provider">Es proveedor de correos</mat-checkbox>
      </div>
    </div>

    <h2 class="dialog-section">Información de facturación</h2>
    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Nombre de facturación</mat-label>
          <input type="text" matInput formControlName="fact_name" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>NIF/CIF</mat-label>
          <input type="text" matInput formControlName="vat" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Dirección de facturación</mat-label>
          <input type="text" matInput formControlName="fact_address" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Población/Ciudad</mat-label>
          <input type="text" matInput formControlName="fact_city" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Código postal</mat-label>
          <input type="text" matInput formControlName="fact_zipcode" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Província</mat-label>
          <input type="text" matInput formControlName="fact_county" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>País</mat-label>
          <mat-select formControlName="fact_country">
            @for (c of countries; track c) {
              <mat-option [value]="c.name">{{ c.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onNoClick()" cdkFocusInitial type="button">Cancelar</button>
  <button mat-button [mat-dialog-close]="providerForm.value" [disabled]="!providerForm.valid" type="submit">
    <mat-icon matPrefix>add_user</mat-icon>
    Crear proveedor
  </button>
</mat-dialog-actions>
